export * from './data.service';
